import React, {useEffect, useState} from 'react';
import './DailyLoginRewardHistoryPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import Pagination from '../../elements/Pagination/Pagination';
import DailyLoginRewardHistoryItem from '../../DailyLoginRewardHistoryItem/DailyLoginRewardHistoryItem';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {API_BASE} from '../../../utils/apiConfig';
import {addClassNameIfTrue} from "../../../utils/other/addClassNameIfTrue";
import {MENU_SOUND_MANAGER} from "../../../scenes/MenuSoundManager";

const PAGE_ID = 'DailyLoginRewardHistoryPage';
const PAGE_SIZE = 10;

function DailyLoginRewardHistoryPage({isAllClaims, userId, userName, onBack, onUserClick}) {
  const [claims, setClaims] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cache, setCache] = useState(new Map());

  usePageAnalytics('DailyLoginRewardHistoryPage');

  useEffect(() => {
    const fetchClaims = async () => {
      setLoading(true);
      setError(null);

      const cacheKey = `${isAllClaims ? 'all' : userId}_${page}`;
      const cached = cache.get(cacheKey);
      if (cached) {
        setClaims(cached.claims);
        setTotalPages(cached.totalPages);
        setLoading(false);
        return;
      }

      try {
        const url = isAllClaims
          ? `${API_BASE}/admin/daily-login-reward-claims?limit=${PAGE_SIZE}&page=${page}`
          : `${API_BASE}/users/${userId}/daily-login-reward-claims?limit=${PAGE_SIZE}&page=${page}`;
        const res = await fetch(url, {
          credentials: 'include',
        });
        if (!res.ok) throw new Error('Failed to fetch daily login reward history');
        const data = await res.json();
        setClaims(data.claims || []);
        setTotalPages(data.totalPages || 1);
        setCache((prev) => {
          const next = new Map(prev);
          next.set(cacheKey, data);
          return next;
        });
      } catch (e) {
        console.error('Daily login reward history error', e);
        setError('Не удалось загрузить историю ежедневных наград');
      } finally {
        setLoading(false);
      }
    };

    fetchClaims();
  }, [page, cache, userId, isAllClaims]);

  const handlePageChange = (newPage) => {
    MENU_SOUND_MANAGER.playMenuButtonClick();
    setPage(newPage);
  };

  let title;
  if (isAllClaims) {
    title = 'Все ежедневные награды';
  } else {
    title = 'История ежедневных наград';
  }

  const isUserNameShown = userName && !isAllClaims

  return (
    <>
      <h1
        className={`admin-user-profile-title ${addClassNameIfTrue(!isUserNameShown, 'history-page-title-margin-bottom')}`}
      >{title}</h1>

      {isUserNameShown && (
        <h1 className="admin-user-profile-name">{userName}</h1>
      )}

      {loading && <p className="daily-login-reward-history-page-status">Загрузка...</p>}
      {error &&
        <p className="daily-login-reward-history-page-status daily-login-reward-history-page-status_error">{error}</p>}

      {!loading && !error && (
        <>
          {claims.length === 0 ? (
            <p className="daily-login-reward-history-page-status">Пока нет полученных наград</p>
          ) : (
            <>
              <div className="daily-login-reward-history-page-list">
                {claims.map((claim, index) => (
                  <DailyLoginRewardHistoryItem
                    key={claim._id}
                    claim={claim}
                    showUserName={isAllClaims}
                    onClick={isAllClaims ? () => onUserClick(claim.userId, claim.userName) : undefined}
                    pageId={PAGE_ID}
                    buttonId={`daily_login_reward_${index}`}
                  />
                ))}
              </div>
              <Pagination currentPage={page} totalPages={totalPages} onPageChange={handlePageChange}/>
            </>
          )}
        </>
      )}

      <div className="main-menu-buttons daily-login-reward-history-page-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default DailyLoginRewardHistoryPage;
